import MuiScopedCssBaseline, {
    ScopedCssBaselineProps as MuiScopedCssBaselineProps
} from '@mui/material/ScopedCssBaseline';
import React, { forwardRef } from 'react';

export const RubiksCssBaseline = forwardRef<
    HTMLDivElement,
    MuiScopedCssBaselineProps
>((props, ref) => {
    return (
        <MuiScopedCssBaseline
            ref={ref}
            {...props}
            sx={{
                display: 'contents',
                background: 'inherit',
                ...props.sx
            }}
        />
    );
});
